import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import i18n from 'i18next';
import { capitalize } from 'lodash';
import head from 'lodash/head';
import isNaN from 'lodash/isNaN';
import { ru, enUS, ar, az, be, de, es, fr, he, hy, ja, ka, kk, tr, uk, uz } from 'date-fns/locale';
import { parse } from 'date-fns';

let days;
let months;

const GET_DAYS = () => [
  i18n.t('mon'),
  i18n.t('tue'),
  i18n.t('wed'),
  i18n.t('thu'),
  i18n.t('fri'),
  i18n.t('sat'),
  i18n.t('sun'),
];

const GET_MONTHS = () => [
  i18n.t('january'),
  i18n.t('february'),
  i18n.t('march'),
  i18n.t('april'),
  i18n.t('may'),
  i18n.t('june'),
  i18n.t('july'),
  i18n.t('august'),
  i18n.t('september'),
  i18n.t('october'),
  i18n.t('november'),
  i18n.t('december'),
];

export const monthsOfYear = () => {
  months =
    months ||
    [...Array(12)].map((_, i) => {
      const baseDate = new Date(2017, i, 1);
      return GET_MONTHS()[baseDate.getMonth()];
    });

  return months;
};

export const getMonthHeaderTemplate = () => {
  days =
    days ||
    [...Array(7)].map((_, i) => {
      const baseDate = new Date(Date.UTC(2017, 0, i + 1));

      // Get full name of this day.
      const dayName = GET_DAYS()[baseDate.getDay()];

      return dayName;
    });

  return days;
};

export const getCurrentMonth = (month, year) => {
  const now = new Date();
  const weekArray = [];

  const currentMonth = isNaN(month) || month == null ? now.getMonth() + 1 : month;
  const currentYear = isNaN(year) || year == null ? now.getFullYear() : year;
  const logicalMonth = currentMonth - 1;

  // get first day of month and first week day
  const firstDay = new Date(currentYear, logicalMonth, 1);
  const firstDayWeekday = firstDay.getDay() === 0 ? 7 : firstDay.getDay();

  // find number of days in month
  const monthLength = new Date(currentYear, currentMonth, 0).getDate();
  const previousMonthLength = new Date(currentYear, logicalMonth, 0).getDate();
  const dateFormat = 'yyyy-MM-dd';

  let day = 1;
  let prev = 1;
  let next = 1;

  for (let i = 0; i < 9; i += 1) {
    weekArray[i] = weekArray[i] || [];

    for (let j = 1; j <= 7; j += 1) {
      if (day <= monthLength && (i > 0 || j >= firstDayWeekday)) {
        const date = new Date(year, month - 1, day);
        weekArray[i].push({ day, date, dateStr: format(date, dateFormat) });
        day += 1;
      } else if (day <= monthLength) {
        const currentDay = previousMonthLength - firstDayWeekday + prev + 1;
        const date = new Date(year, month - 2, currentDay);

        weekArray[i].push({
          day: currentDay,
          isPrev: true,
          date,
          dateStr: format(date, dateFormat),
        });
        prev += 1;
      } else {
        const date = new Date(year, month, next);

        weekArray[i].push({
          day: next,
          isNext: true,
          date,
          dateStr: format(date, dateFormat),
        });
        next += 1;
      }
    }

    // stop making rows if it's the end of month
    if (day > monthLength) {
      break;
    }
  }

  return weekArray;
};

export const getTimeFormat = (convertToAmPmTime, lang) => {
  const notLang = lang !== 'ru' && lang !== 'be' && lang !== 'uk' && lang !== 'he';

  return convertToAmPmTime && notLang ? `hh:mm aa` : 'HH:mm';
};

export const parseDate = (date) => new Date(date.replace(/-/g, '/'));

export const getTimesInDays = ({ dates, convertToAmPmTime, lang }) =>
  dates.reduce((addMap, curr) => {
    const date = curr.date;
    const day = head(date.split(' '));
    const arr = addMap.get(day) || [];
    const timeFormat = getTimeFormat(convertToAmPmTime, lang);

    arr.push({
      ...curr,
      date: new Date(parseDate(date)),
      time: format(parseISO(date), timeFormat),
    });

    addMap.set(day, arr);

    return addMap;
  }, new Map());

export const getNextMonth = ({ month, year, delta }) => {
  let nextMonth = month + delta;
  let nextYear = year;

  if (nextMonth < 1) {
    nextMonth = 12 + nextMonth;
    nextYear -= 1;
  }
  if (nextMonth > 12) {
    nextMonth -= 12;
    nextYear += 1;
  }

  return {
    nextMonth,
    nextYear,
  };
};

export const formatDateAnnouncement = (dateString, locale) => {
  if (!dateString) {
    return '';
  }

  const parsedDate = parse(dateString, 'yyyy-MM-dd HH:mm:ss', new Date());
  if (isNaN(parsedDate.getTime())) {
    return '';
  }

  const localeMap = {
    ar,
    az,
    be,
    de,
    en: enUS,
    es,
    fr,
    he,
    hy,
    ja,
    ka,
    kk,
    tr,
    ru,
    uk,
    uz,
  };

  const formattedDate = format(parsedDate, "EEEE, d MMMM 'в' HH:mm", {
    locale: localeMap[locale] || ru,
  });

  return capitalize(formattedDate);
};
